/**
 * @fileoverview gRPC-Web generated client stub for pbs
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var common_pb = require('./common_pb.js')
const proto = {};
proto.pbs = require('./school_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.SchoolServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.SchoolServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.School,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_SchoolService_Create = new grpc.web.MethodDescriptor(
  '/pbs.SchoolService/Create',
  grpc.web.MethodType.UNARY,
  proto.pbs.School,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.School} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.School,
 *   !proto.pbs.Empty>}
 */
const methodInfo_SchoolService_Create = new grpc.web.AbstractClientBase.MethodInfo(
  common_pb.Empty,
  /**
   * @param {!proto.pbs.School} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.School} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.SchoolServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.SchoolService/Create',
      request,
      metadata || {},
      methodDescriptor_SchoolService_Create,
      callback);
};


/**
 * @param {!proto.pbs.School} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     A native promise that resolves to the response
 */
proto.pbs.SchoolServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.SchoolService/Create',
      request,
      metadata || {},
      methodDescriptor_SchoolService_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.School,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_SchoolService_Update = new grpc.web.MethodDescriptor(
  '/pbs.SchoolService/Update',
  grpc.web.MethodType.UNARY,
  proto.pbs.School,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.School} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.School,
 *   !proto.pbs.Empty>}
 */
const methodInfo_SchoolService_Update = new grpc.web.AbstractClientBase.MethodInfo(
  common_pb.Empty,
  /**
   * @param {!proto.pbs.School} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.School} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.SchoolServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.SchoolService/Update',
      request,
      metadata || {},
      methodDescriptor_SchoolService_Update,
      callback);
};


/**
 * @param {!proto.pbs.School} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     A native promise that resolves to the response
 */
proto.pbs.SchoolServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.SchoolService/Update',
      request,
      metadata || {},
      methodDescriptor_SchoolService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.SchoolId,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_SchoolService_Delete = new grpc.web.MethodDescriptor(
  '/pbs.SchoolService/Delete',
  grpc.web.MethodType.UNARY,
  proto.pbs.SchoolId,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.SchoolId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.SchoolId,
 *   !proto.pbs.Empty>}
 */
const methodInfo_SchoolService_Delete = new grpc.web.AbstractClientBase.MethodInfo(
  common_pb.Empty,
  /**
   * @param {!proto.pbs.SchoolId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.SchoolId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.SchoolServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.SchoolService/Delete',
      request,
      metadata || {},
      methodDescriptor_SchoolService_Delete,
      callback);
};


/**
 * @param {!proto.pbs.SchoolId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     A native promise that resolves to the response
 */
proto.pbs.SchoolServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.SchoolService/Delete',
      request,
      metadata || {},
      methodDescriptor_SchoolService_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.SchoolListReq,
 *   !proto.pbs.Schools>}
 */
const methodDescriptor_SchoolService_List = new grpc.web.MethodDescriptor(
  '/pbs.SchoolService/List',
  grpc.web.MethodType.UNARY,
  proto.pbs.SchoolListReq,
  proto.pbs.Schools,
  /**
   * @param {!proto.pbs.SchoolListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Schools.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.SchoolListReq,
 *   !proto.pbs.Schools>}
 */
const methodInfo_SchoolService_List = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pbs.Schools,
  /**
   * @param {!proto.pbs.SchoolListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Schools.deserializeBinary
);


/**
 * @param {!proto.pbs.SchoolListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Schools)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Schools>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.SchoolServiceClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.SchoolService/List',
      request,
      metadata || {},
      methodDescriptor_SchoolService_List,
      callback);
};


/**
 * @param {!proto.pbs.SchoolListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Schools>}
 *     A native promise that resolves to the response
 */
proto.pbs.SchoolServicePromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.SchoolService/List',
      request,
      metadata || {},
      methodDescriptor_SchoolService_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.GetSchoolReq,
 *   !proto.pbs.Schools>}
 */
const methodDescriptor_SchoolService_GetSchool = new grpc.web.MethodDescriptor(
  '/pbs.SchoolService/GetSchool',
  grpc.web.MethodType.UNARY,
  proto.pbs.GetSchoolReq,
  proto.pbs.Schools,
  /**
   * @param {!proto.pbs.GetSchoolReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Schools.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.GetSchoolReq,
 *   !proto.pbs.Schools>}
 */
const methodInfo_SchoolService_GetSchool = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pbs.Schools,
  /**
   * @param {!proto.pbs.GetSchoolReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Schools.deserializeBinary
);


/**
 * @param {!proto.pbs.GetSchoolReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Schools)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Schools>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.SchoolServiceClient.prototype.getSchool =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.SchoolService/GetSchool',
      request,
      metadata || {},
      methodDescriptor_SchoolService_GetSchool,
      callback);
};


/**
 * @param {!proto.pbs.GetSchoolReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Schools>}
 *     A native promise that resolves to the response
 */
proto.pbs.SchoolServicePromiseClient.prototype.getSchool =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.SchoolService/GetSchool',
      request,
      metadata || {},
      methodDescriptor_SchoolService_GetSchool);
};


module.exports = proto.pbs;

